import { render, staticRenderFns } from "./alarmTip.vue?vue&type=template&id=6d77fcb1&scoped=true&"
import script from "./alarmTip.vue?vue&type=script&lang=js&"
export * from "./alarmTip.vue?vue&type=script&lang=js&"
import style0 from "./alarmTip.vue?vue&type=style&index=0&id=6d77fcb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d77fcb1",
  null
  
)

export default component.exports